import { render, staticRenderFns } from "./SubsidyStandardSetting.vue?vue&type=template&id=5db619ad&scoped=true"
import script from "./SubsidyStandardSetting.vue?vue&type=script&lang=js"
export * from "./SubsidyStandardSetting.vue?vue&type=script&lang=js"
import style0 from "./SubsidyStandardSetting.vue?vue&type=style&index=0&id=5db619ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db619ad",
  null
  
)

export default component.exports